export default __webpack_public_path__ + "static/compareItemImg3-884d1f42d24bbe2a789096d911f7a453.png";